import React, { useRef, useState } from "react";
import { useDrag, DragPreviewImage } from "react-dnd";
import { useDispatch } from "react-redux";
import { Tooltip, Dialog } from "@material-ui/core";
import "./card.css";
import "../../res/placeholder.png";
import { setSelectedCard } from "../../Redux/actions";

const Card = ({ cardInfo, isDraggable, index }) => {
    const [isHovering, setHovering] = useState(false);
    const [open, setOpen] = useState(false);
    const [isAdded, setIsAdded] = useState(false); // Estado de animación
    const [isClicked, setIsClicked] = useState(false); // Estado para animación de clic
    const dispatch = useDispatch();
    const img_url = `/images/${cardInfo.Ruta?.replace(/\.png$/i, '.webp')}`;

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setHovering(false);
    };

    const handleClick = (event) => {
        setHovering(false);
        if (event.buttons === 2) {
            handleClickOpen();
            event.preventDefault();
            return false;
        }

    };

    const handleAddToDeck = () => {
        if (isDraggable) {
            setIsAdded(true); // Activa la animación
            dispatch({ type: "ADD_CARD_TO_DECK", payload: cardInfo });
            dispatch({ type: "UPDATE_DECK_GROUPS" });
            console.log("Carta añadida, activando animación"); // Debugging

            // Resetea la animación después de 0.5s
            setTimeout(() => {
                setIsAdded(false);
                console.log("Animación terminada"); // Debugging
            }, 500);
        } else {
            dispatch({ type: "REMOVE_CARD", index, payload: { type: cardInfo.type } });
            dispatch({ type: "UPDATE_DECK_GROUPS" });
        }
    };

    const [, drag, conn] = useDrag({
        item: { type: "Card", card: cardInfo },
    });

    const TooltipDisplay = (
        <div>
            {cardInfo.Nombre && <span>Nombre: {cardInfo.Nombre}<br /></span>}
            {cardInfo.Tipo && <span>Tipo: {cardInfo.Tipo}<br /></span>}
            {cardInfo.Raza && <span>Raza: {cardInfo.Raza}<br /></span>}
            {cardInfo.Fuerza && <span>Fuerza: {cardInfo.Fuerza}<br /></span>}
            {cardInfo.Coste && <span>Coste: {cardInfo.Coste}<br /></span>}
            {cardInfo.Habilidad && <span>Habilidad: {cardInfo.Habilidad}<br /></span>}
        </div>
    );
/*
    const DialogDisplay = (
        <div className="card-modal">
            {img_url ? <img src={img_url} alt="Card preview" /> : null}
            <div>
                {cardInfo.Nombre && <span>{cardInfo.Nombre}<br /></span>}
                {cardInfo.Tipo && <span>Tipo: {cardInfo.Tipo}<br /></span>}
                {cardInfo.Raza && <span>Raza: {cardInfo.Raza}<br /></span>}
                {cardInfo.Fuerza && <span>Fuerza: {cardInfo.Fuerza}<br /></span>}
                {cardInfo.Coste && <span>Coste: {cardInfo.Coste}<br /></span>}
                {cardInfo.Habilidad && <span>Habilidad: {cardInfo.Habilidad}<br /></span>}
            </div>
        </div>
    );
*/
    return (
         <Tooltip title={TooltipDisplay} placement="right" open={isHovering && !open} onClose={handleClose}>
            <div
                className={`card ${isAdded ? "added" : ""} ${isClicked ? "clicked" : ""}`}  
                onMouseOver={() => setHovering(true)} 
                onMouseOut={() => setHovering(false)}
            >

                <div className="image-container">
                    <img
                        src={img_url}
                        ref={isDraggable ? drag : null}
 
                        onMouseDown={handleClick}
                        onClick={handleAddToDeck} 
                        style={{ pointerEvents: isAdded ? "none" : "auto" }} // Desactiva clics mientras se anima
                    />
                    
                </div>
                {/* <Dialog open={open} onClose={handleClose} onBackdropClick={() => setOpen(false)} maxWidth="md">
                    {DialogDisplay}
                </Dialog> */}
            </div>
         </Tooltip>
    );
};
export default Card;
